import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
//Components
import { LCAlert } from '../../../components/alert';
import App from '../../../components/app';
import ErrorMessage from '../../../components/error-message';
import EnhancedForm from '../../../components/form';
import { FormDatas } from '../../../local-types';
// Modules
import { DispatchGroup, PayloadCreationVehicleType, VehicleTypeById } from '../../../redux/reducers/api-types';
import { ErrorPayload, selectors as errorSelectors } from '../../../redux/reducers/errors';
import {
    actions as vehicleActions,
    selectors as vehicleSelectors,
    types as vehicleActionTypes,
} from '../../../redux/reducers/vehicles';
import { selectors as pendingSelectors } from '../../../redux/reducers/pendingOperations';
import { actions as driverActions, selectors as driverSelectors } from '../../../redux/reducers/drivers';
// Ressources
import styles from './vehicles-types-add-style';
import { AccountRight, RightRank } from '../../../utils/userUtils';
import { paths } from '../../paths';

const queryString = require('query-string');

interface VehiclesTypesAddProps extends WithTranslation, RouteComponentProps {
    vehicleTypes: VehicleTypeById;
    getVehicleTypesError: ErrorPayload;
    saveVehicleTypeError: ErrorPayload;
    getDispatchGroupsError: ErrorPayload;
    dispatchGroups: DispatchGroup[];
    getVehicleType: (id: string) => any;
    saveVehicleType: (payload: PayloadCreationVehicleType) => any;
    isSavingVehicleType: boolean;
    getDispatchGroups: () => any;
}

interface VehiclesTypesAddState {
    formData: any;
}

class VehiclesTypesAddPage extends React.Component<VehiclesTypesAddProps, VehiclesTypesAddState> {
    alertRef: any;

    state = {
        formData: {},
    };

    componentDidMount() {
        const params = queryString.parse(this.props.location.search);
        if (params.id) {
            this.props.getVehicleType(params.id);
        }
        if (this.props.dispatchGroups.length === 0) {
            this.props.getDispatchGroups();
        }
    }

    static getDerivedStateFromProps(props, state) {
        const params = queryString.parse(props.location.search);
        const payload = props.vehicleTypes[params.id];
        if (payload && !state.formData.id) {
            return { formData: payload };
        }
        return null;
    }

    generateInputs() {
        const { t, dispatchGroups } = this.props;
        const keysDispatchGroups: any = dispatchGroups.reduce((acc, val) => ({ ...acc, [val.id]: val }), {});

        const generateLabel = (key: string, prefix = false) => {
            return (prefix ? t('form.available') : '') + keysDispatchGroups[key]?.name;
        };

        const inputs: FormDatas[] = [
            {
                title: t('common:form.general_infos'),
                datas: [
                    { id: 'brand', label: t('brand'), required: true },
                    { id: 'model', label: t('model'), required: true },
                    {
                        id: 'age_max',
                        label: t('form.age_max'),
                        type: 'number',
                        inputsAttributs: { step: 1 },
                        required: true,
                    },
                    {
                        id: 'isVan',
                        label: generateLabel('van'),
                        type: 'boolean',
                        linked: [
                            // { id: 'isBike', value: false },
                            { id: 'isExec', value: false },
                            { id: 'isAccess', value: false },
                        ],
                    },
                    // {
                    //     id: 'isBike',
                    //     label: generateLabel('moto'),
                    //     type: 'boolean',
                    //     linked: [
                    //         { id: 'isVan', value: false },
                    //         { id: 'isExec', value: false },
                    //     ],
                    // },
                    {
                        id: 'isExec',
                        label: generateLabel('exec'),
                        type: 'boolean',
                        linked: [
                            { id: 'isVan', value: false },
                            // { id: 'isBike', value: false },
                            { id: 'isAccess', value: false },
                        ],
                    },
                    {
                        id: 'isGreen',
                        label: generateLabel('green', true),
                        type: 'boolean',
                        linked: [
                            { id: 'isVan', value: false },
                            // { id: 'isBike', value: false },
                            { id: 'isExec', value: false },
                            { id: 'isAccess', value: false },
                        ],
                    },
                    {
                        id: 'isBerline',
                        label: generateLabel('normal', true),
                        type: 'boolean',
                        linked: [
                            { id: 'isVan', value: false },
                            // { id: 'isBike', value: false },
                            { id: 'isExec', value: false },
                            { id: 'isAccess', value: false },
                        ],
                    },
                    {
                        id: 'isAccess',
                        label: generateLabel('access', true),
                        type: 'boolean',
                        linked: [
                            { id: 'isVan', value: false },
                            // { id: 'isBike', value: false },
                            { id: 'isExec', value: false },
                            { id: 'isBerline', value: false },
                        ],
                    },
                    {
                        id: 'age_inf_berline',
                        label: t('form.age_inf_berline'),
                        type: 'number',
                        inputsAttributs: { step: 1 },
                        linked: [
                            { id: 'isVan', value: false },
                            { id: 'isBerline', value: true },
                            { id: 'isExec', value: false },
                            { id: 'isAccess', value: false },
                        ],
                        required: true,
                    },
                ],
            },
        ];

        // Test automatic add from dispatchGroups - KO
        // const test: { id: string; label: string }[] = dispatchGroups.map((dg) => {
        //     return { id: dg.id, label: dg.name, type: 'boolean' };
        // });

        // inputs[0].datas.push(...test);

        return inputs;
    }

    render() {
        const {
            t,
            location,
            vehicleTypes,
            dispatchGroups,
            getVehicleTypesError,
            saveVehicleTypeError,
            getDispatchGroupsError,
            saveVehicleType,
            isSavingVehicleType,
        } = this.props;
        const params = queryString.parse(location.search);
        const payload = vehicleTypes[params.id] || ({} as any);

        return (
            <App needRights={{ name: AccountRight.PARTNER_SETTINGS, mode: RightRank.W }}>
                <ErrorMessage payload={getVehicleTypesError || getDispatchGroupsError || saveVehicleTypeError} />
                {(params.id == null || payload?.id != null) && dispatchGroups.length > 0 && (
                    <EnhancedForm
                        payload={this.state.formData}
                        inputs={this.generateInputs()}
                        backRoute={paths.vehiclesTypes}
                        moreView={
                            <LCAlert
                                onRef={(ref) => (this.alertRef = ref)}
                                details={t('form.error_age')}
                                type="error"
                            />
                        }
                        loader={isSavingVehicleType}
                        onSubmit={(_, _event, _stringify, _keepFormData, formData) => {
                            this.setState({
                                formData: formData,
                            });
                            const { age_max, age_inf_berline, isBerline } = formData;
                            if (isBerline && age_max && age_inf_berline && age_max < age_inf_berline) {
                                this.alertRef.showAlert();
                            } else {
                                this.alertRef.closeAlert();
                                saveVehicleType(formData);
                            }
                        }}
                    />
                )}
            </App>
        );
    }
}

const VehiclesTypesAddPageWithStyleAndTranslation = withStyles(styles)(
    withTranslation(['vehicle', 'common'])(VehiclesTypesAddPage),
);

const mapStateToProps = (state) => ({
    vehicleTypes: vehicleSelectors.vehicleTypes(state),
    dispatchGroups: driverSelectors.sortedDispatchGroup(state),
    getVehicleTypesError: errorSelectors.getVehicleTypesError(state),
    saveVehicleTypeError: errorSelectors.saveVehicleTypeError(state),
    isSavingVehicleType: pendingSelectors.isPending(state, vehicleActionTypes.SAVE_VEHICLE_TYPE),
    getDispatchGroupsError: errorSelectors.getDispatchGroupsError(state),
});

const mapDispatchToProps = {
    getVehicleType: vehicleActions.getVehicleType,
    saveVehicleType: vehicleActions.saveVehicleType,
    getDispatchGroups: driverActions.getDispatchGroups,
};

export default connect(mapStateToProps, mapDispatchToProps)(VehiclesTypesAddPageWithStyleAndTranslation);
